import { Reveal } from "@/components/Motion";
import { ASSETS } from "@/data/content";
import { Target, Layers, Award ,BadgeCheck} from "lucide-react";

const POINTS = [
  {
    icon: Target,
    title: "Purpose-Built",
    body: "Designed for professionals mastering the security of modern AI and LLM systems.",
  },
  {
    icon: Layers,
    title: "Five Domains",
    body: "Foundations, offensive exploitation, risk & governance, and defensive controls.",
  },
  {
    icon: Award,
    title: "Advanced Credential",
    body: "A rigorous, exam based certification recognised across the security industry.",
  },
  {
    icon: BadgeCheck,
    title: "75% Passing Benchmark",
    body: "Vendor neutral accreditation rigorous benchmark validating core competence in LLM, RAG & agentic safety",
  },
];

const AboutHcasp = () => {
  return (
    <section
      id="about-hcasp"
      data-testid="about-hcasp"
      className="relative py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
                [ 002 ] About HCASP
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
                The advanced standard for AI security.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 font-body text-lg text-[#97b8ff] leading-relaxed">
                The Hacktonomy Certified AI Security Professional (HCASP) is a foundational to intermediate, vendor neutral certification designed to validate your core understanding of Artificial Intelligence and Machine Learning security. As Generative AI and LLMs rapidly integrate into enterprise software and workflows, HCASP bridges the critical gap between basic IT security and practical AI vulnerability awareness.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-5 font-body text-base text-white/70 leading-relaxed">
                The certification focuses on practical security concepts, OWASP Top 10 for LLM Applications, introductory red teaming, agentic safety basics, Model Context Protocol (MCP), secure AI coding, and operational guardrails.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            <Reveal className="sm:col-span-2">
              <div className="relative overflow-hidden rounded-2xl border border-[#3d414f] h-52">
                <img
                  src={ASSETS.cyberPro}
                  alt="Cybersecurity training"
                  className="w-full h-full object-cover opacity-70"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-[#07070c] via-[#07070c]/60 to-transparent" />
                <div className="absolute inset-0 flex flex-col justify-center px-8">
                  <div className="font-display font-700 text-3xl text-white">
                    Master AI Security
                  </div>
                  <div className="mt-2 font-mono2 text-xs uppercase tracking-[0.2em] text-[#16fcfb]">
                    Offensive · Defensive · Governance
                  </div>
                </div>
              </div>
            </Reveal>

            {POINTS.map((p, i) => (
              <Reveal key={p.title} delay={0.08 * i}>
                <div className="group h-full rounded-2xl border border-[#3d414f] bg-[#404452]/25 p-7 transition-colors duration-300 hover:border-[#16fcfb]">
                  <p.icon className="text-[#16fcfb]" size={26} />
                  <h3 className="mt-5 font-display font-600 text-lg text-white">
                    {p.title}
                  </h3>
                  <p className="mt-2 font-body text-sm text-white/65 leading-relaxed">
                    {p.body}
                  </p>
                </div>
              </Reveal>
            ))}
            {/* <Reveal delay={0.24}>
              <div className="h-full rounded-2xl border border-[#16fcfb]/40 bg-[#16fcfb]/5 p-7 flex flex-col justify-center">
                <div className="font-display font-900 text-4xl text-[#16fcfb] text-glow-cyan">
                  75%
                </div>
                <div className="mt-2 font-mono2 text-[11px] uppercase tracking-[0.15em] text-[#97b8ff]">
                  PASSING BENCHMARK  VENDOR NEUTRAL ACCREDITATION
                  Rigorous benchmark validating core competence in LLM, RAG & agentic safety
                </div>
              </div>
            </Reveal> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHcasp;
